import * as React from 'react'

import { List } from '../../list'

interface IListRendererProps {
  children?: React.ReactNode
  ordered: boolean
}

export default function ListRenderer({ children, ordered }: IListRendererProps) {
  const type = ordered ? 'ordered' : 'unordered'

  return (
    <List displayBullets style={{ ':last-child': { marginBottom: 0 } }} type={type}>
      {children}
    </List>
  )
}
